// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.91 1H3V23H21V7.09L14.91 1ZM15 10.5C15 12.1569 13.6569 13.5 12 13.5C10.3431 13.5 9 12.1569 9 10.5C9 8.84315 10.3431 7.5 12 7.5C13.6569 7.5 15 8.84315 15 10.5ZM6 19C6 16.7909 7.79086 15 10 15H14C16.2091 15 18 16.7909 18 19V20H6V19Z"}}]};

const PersonalInformationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'personal-information-filled',
    ref,
    icon: element,
  },
));

PersonalInformationFilledIcon.displayName = 'PersonalInformationFilledIcon';

export default PersonalInformationFilledIcon;
